import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Dialog } from 'primereact/dialog';
import { AutoComplete } from 'primereact/autocomplete';
import { Checkbox } from 'primereact/checkbox';

import { buscarNcm, buscarCest } from '../tributosApi';

const soDigitos = (v, max) => String(v || '').replace(/\D/g, '').substring(0, max);

/** Janela de alteração rápida de NCM (e CEST) usada em Alteração por NCM e Recebimentos. */
export default function AlterarNcmDialog({
  visible, titulo, mensagem, ncmInicial, salvando, onHide, onConfirmar,
}) {
  const [ncm, setNcm] = useState('');
  const [cest, setCest] = useState('');
  const [limparCest, setLimparCest] = useState(false);
  const [sugestoesNcm, setSugestoesNcm] = useState([]);
  const [sugestoesCest, setSugestoesCest] = useState([]);

  useEffect(() => {
    if (visible) {
      setNcm(soDigitos(ncmInicial, 8));
      setCest('');
      setLimparCest(false);
    }
  }, [visible, ncmInicial]);

  const completarNcm = e => {
    const q = soDigitos(e.query, 8);
    if (q.length < 2) { setSugestoesNcm([]); return; }
    buscarNcm(q).then(l => setSugestoesNcm((l || []).slice(0, 40))).catch(() => setSugestoesNcm([]));
  };

  const completarCest = e => {
    const q = soDigitos(e.query, 7);
    if (q.length < 2) { setSugestoesCest([]); return; }
    buscarCest(q).then(l => setSugestoesCest((l || []).slice(0, 40))).catch(() => setSugestoesCest([]));
  };

  const itemTemplate = item => (
    <div className="tb-ac-item"><strong>{item.codigo}</strong><span>{item.descricao}</span></div>
  );

  const valido = ncm.length === 8 && (cest === '' || cest.length === 7);

  const confirmar = () => {
    if (!valido || salvando) return;
    onConfirmar({ ncm, cest: cest || undefined, limparCest: !cest && limparCest });
  };

  return (
    <Dialog
      className="tb-dialog"
      header={titulo}
      visible={visible}
      onHide={() => !salvando && onHide()}
      style={{ width: '32rem', maxWidth: '95vw' }}
      footer={(
        <div>
          <button type="button" className="tb-btn tb-btn-ghost" onClick={onHide} disabled={salvando}>Cancelar</button>
          <button type="button" className="tb-btn tb-btn-primary" onClick={confirmar} disabled={!valido || salvando}>
            {salvando ? <i className="pi pi-spin pi-spinner" /> : <i className="pi pi-check" />} Alterar NCM
          </button>
        </div>
      )}
    >
      {mensagem ? <p className="tb-obs">{mensagem}</p> : null}
      <div className="tb-grid">
        <div className="tb-field tb-span-6">
          <label htmlFor="altNcm">Novo NCM</label>
          <AutoComplete
            inputId="altNcm"
            value={ncm}
            suggestions={sugestoesNcm}
            completeMethod={completarNcm}
            field="codigo"
            itemTemplate={itemTemplate}
            onChange={e => setNcm(typeof e.value === 'string' ? soDigitos(e.value, 8) : ncm)}
            onSelect={e => setNcm(soDigitos(e.value.codigo, 8))}
            placeholder="8 dígitos"
            inputClassName="tb-mono"
            delay={350}
            autoFocus
          />
        </div>
        <div className="tb-field tb-span-6">
          <label htmlFor="altCest">Novo CEST (opcional)</label>
          <AutoComplete
            inputId="altCest"
            value={cest}
            suggestions={sugestoesCest}
            completeMethod={completarCest}
            field="codigo"
            itemTemplate={itemTemplate}
            onChange={e => setCest(typeof e.value === 'string' ? soDigitos(e.value, 7) : cest)}
            onSelect={e => setCest(soDigitos(e.value.codigo, 7))}
            placeholder="Em branco = mantém"
            inputClassName="tb-mono"
            delay={350}
          />
        </div>
      </div>
      {!cest ? (
        <span className="tb-lote-opcao" style={{ marginTop: 10 }}>
          <Checkbox inputId="altLimparCest" checked={limparCest} onChange={e => setLimparCest(e.checked)} />
          <label htmlFor="altLimparCest">Remover o CEST atual</label>
        </span>
      ) : null}
      {ncm && ncm.length !== 8 ? <small className="tb-hint tb-hint-erro">O NCM deve ter 8 dígitos.</small> : null}
      {cest && cest.length !== 7 ? <small className="tb-hint tb-hint-erro">O CEST deve ter 7 dígitos.</small> : null}
    </Dialog>
  );
}

AlterarNcmDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  titulo: PropTypes.string,
  mensagem: PropTypes.node,
  ncmInicial: PropTypes.string,
  salvando: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirmar: PropTypes.func.isRequired,
};

AlterarNcmDialog.defaultProps = {
  titulo: 'Alterar NCM',
  mensagem: null,
  ncmInicial: '',
  salvando: false,
};
